import {
  Component,
  HostBinding,
} from '@angular/core';

@Component({
  selector: 'suka-form-layout',
  template: `
    <div class="form-layout__wrapper">
      <ng-content></ng-content>
    </div>
  `
})
export class FormLayout {
  @HostBinding('class.form-layout') baseClass = true;
}
